import React from 'react';
import { arrayOf, node, shape, string } from 'prop-types';

import LinkListComponent from './styles';

export default function LinkList(props) {
  const { heading, items } = props;
  return (
    <LinkListComponent>
      {heading && (
        <LinkListComponent.Header>{heading}</LinkListComponent.Header>
      )}
      <LinkListComponent.List>
        {items.map((item) => (
          <LinkListComponent.ListItem key={item.text}>
            <LinkListComponent.Link href={item.href}>
              {item.text}
            </LinkListComponent.Link>
          </LinkListComponent.ListItem>
        ))}
      </LinkListComponent.List>
    </LinkListComponent>
  );
}

LinkList.defaultProps = {
  heading: null,
  items: [],
};

LinkList.propTypes = {
  heading: string,
  items: arrayOf(
    shape({
      href: string,
      text: node,
    })
  ),
};
